import React from "react";
import { useContent } from "../i18n/LanguageContext";
import { Phone, ArrowRight } from "lucide-react";

export default function Corporate({ onContact }) {
  const corporate = useContent().corporate;
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl reveal">
          <div className="eyebrow mb-4">{corporate.eyebrow}</div>
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold">{corporate.title}</h2>
          <p className="mt-4 text-[#5c6577] text-lg">{corporate.text}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {corporate.people.map((p) => (
            <div key={p.name} className="card-lift bg-white rounded-xl border border-[#efe9dd] p-7">
              <div className="flex items-center gap-4 mb-5">
                <div className="w-14 h-14 rounded-full bg-[#16233d] flex items-center justify-center">
                  <span className="font-serif-lux text-xl text-[#d3b077]">{p.initials}</span>
                </div>
                <div>
                  <h3 className="font-serif-lux text-xl text-[#16233d]">{p.name}</h3>
                  <div className="text-sm text-[#b08d57]">{p.role}</div>
                </div>
              </div>
              <div className="text-sm text-[#5c6577] mb-4">{p.region}</div>
              <a href={`tel:${p.phone.replace(/\s/g, "")}`} className="flex items-center gap-2.5 text-[#16233d] hover:text-[#b08d57] transition-colors border-t border-[#f0ece3] pt-4">
                <Phone size={16} className="text-[#b08d57]" /> <span className="text-sm font-medium">{p.phone}</span>
              </a>
            </div>
          ))}
        </div>

        <div className="mt-16 rounded-2xl bg-[#faf8f4] border border-[#efe9dd] px-8 py-12 text-center">
          <h3 className="font-serif-lux text-3xl lg:text-4xl text-[#16233d] font-semibold">{corporate.ctaTitle}</h3>
          <p className="mt-3 text-[#5c6577]">{corporate.ctaText}</p>
          <button onClick={onContact} className="btn-gold rounded-md px-7 py-3.5 font-medium mt-7 inline-flex items-center gap-2">
            {corporate.ctaBtn} <ArrowRight size={17} />
          </button>
        </div>
      </div>
    </section>
  );
}
